// extracted by mini-css-extract-plugin
module.exports = {"content":"WebinarHeroSingle_content__O_GgS","title":"WebinarHeroSingle_title__1FPam","textWrapper":"WebinarHeroSingle_textWrapper__KowYU"};